import type { Quote } from '../../types/quotes/quote'
import type { RelatedInvoice } from '../../types/relatedInvoice'
import { isFinalInvoice } from './isFinalInvoice'

export const getQuoteFinalInvoiceDraft = (quote?: Quote): RelatedInvoice | undefined =>
  quote?.relatedInvoices?.find(
    (relatedInvoice) => !!relatedInvoice.invoiceDraftId && isFinalInvoice(relatedInvoice.billingStage),
  )
